import script from "./FailedJobs.vue?vue&type=script&setup=true&lang=js"
export * from "./FailedJobs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__